import moment from "moment";

export const formatControlInterno = (value) => {
  if (value === null || value === undefined || value === "") {
    return "N/D";
  } else if (value.includes("/")) {
    const firstPart = value.split("/")[0];
    if (firstPart === "") {
      return value;
    } else {
      return firstPart;
    }
  } else {
    return value;
  }
};

export const formatFullControlInterno = (value) => {
  return value === null || value === undefined || value === "" ? "N/D" : value;
};

export const formatFullDate = (dateStr) => {
  return moment(dateStr).format("DD [de] MMMM [del año] YYYY");
};

export const getTypeAbbreviation = (type) => {
  const abbreviations = {
    solicitud: "Solicitud",
    contrato: "Contrato",
    listo: "Marcado Listo",
    // revision: "Proy.",
    revision1: "Inicia Rev.",
    revision2: "Termina Rev.",
    emision: "Emitido",
    papeleria: "Entrega papelería",
    cancelacion: "Cancelado",
  };
  return abbreviations[type] || type;
};

export const getTypeFullName = (type) => {
  const fullNames = {
    visita: "Visita",
    solicitud: "Solicitud",
    contrato: "Contrato",
    listo: "Listo",
    // revision: "Revisión",
    revision1: "Inicia Revisión",
    revision2: "Termina Revisión",
    emision: "Emisión",
    papeleria: "Papelería",
    cancelacion: "Cancelación",
  };
  return fullNames[type] || type;
};

export const getStatusLabel = (status) => {
  switch (status) {
    case 1:
      return "En proceso";
    case 2:
      return "En revisión";
    case 3:
      return "Emitido";
    case 4:
      return "Pagado";
    case 5:
      return "Cancelado";
    default:
      return "Desconocido";
  }
};

export const detectOverlappingVisitas = (visitasForDay) => {
  const activeVisitas = visitasForDay.filter((visita) => visita.Status !== 5);
  const overlappingPairs = [];
  for (let i = 0; i < activeVisitas.length; i++) {
    for (let j = i + 1; j < activeVisitas.length; j++) {
      const visita1 = activeVisitas[i];
      const visita2 = activeVisitas[j];
      if (visita1.Hora1 && visita1.Hora2 && visita2.Hora1 && visita2.Hora2) {
        const start1 = moment(visita1.Hora1, "HH:mm");
        const end1 = moment(visita1.Hora2, "HH:mm");
        const start2 = moment(visita2.Hora1, "HH:mm");
        const end2 = moment(visita2.Hora2, "HH:mm");
        if (start1.isBefore(end2) && start2.isBefore(end1)) {
          overlappingPairs.push([visita1.id, visita2.id]);
        }
      }
    }
  }
  return overlappingPairs;
};